module.exports = __webpack_public_path__ + "static/media/Terrorblade.113da199.png";